import { store } from '../../redux/app/store';
import { EmptyGuid } from '../../components/shared/Alerts';

export const BackendServiceUrl =
    process.env.REACT_APP_BACKEND_URI == null || process.env.REACT_APP_BACKEND_URI.trim() === ''
        ? window.origin
        : process.env.REACT_APP_BACKEND_URI;

export const NetworkErrorMessage = '\n\nPlease check that your backend is running and that it is accessible by the app';

export class FileDownloadService {
    private accessToken: string | null = null;
    private readonly serviceUrl: string;

    constructor(serviceUrl: string = BackendServiceUrl) { // Default to BackendServiceUrl
        this.serviceUrl = serviceUrl;
    }

    /**
     * Sets the access token.
     * @param token Bearer token
     */
    public setAccessToken(token: string) {
        this.accessToken = token;
    }

    /**
     * Downloads a file from the specified URL.
     * @param commandPath API endpoint for the download operation
     * @param query Optional query parameters
     */
    public downloadFileAsync = async (
        commandPath: string,
        query?: URLSearchParams,
    ): Promise<void> => {

        // Determine the tenant ID
        const { activeUserInfo } = store.getState().app;

        const tenantId = typeof activeUserInfo?.activeTenantId === 'string' ? activeUserInfo.activeTenantId : EmptyGuid;

        // Create headers
        const headers = new Headers(
            this.accessToken
                ? {
                    Authorization: `Bearer ${this.accessToken}`,
                    'X-Tenant-Id': tenantId,
                }
                : undefined,
        );

        const requestUrl = new URL(commandPath, this.serviceUrl);
        if (query) {
            requestUrl.search = `?${query.toString()}`;
        }
        try {
            const response = await fetch(requestUrl.toString(), {
                method: 'GET',
                headers,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            // Create a Blob URL
            const url = window.URL.createObjectURL(blob);

            // Initiate the download
            const anchor = document.createElement('a');
            anchor.href = url;

            // Determine the file name
            const fileNameMatch = commandPath.match(/filename=([^&]+)/);
            const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : 'downloaded_file';

            console.log('File name:', fileName); // Log the file name to the console

            anchor.download = fileName; // Set the file name for the download
            document.body.appendChild(anchor); // Append the anchor to the DOM
            anchor.click(); // Simulate a click
            document.body.removeChild(anchor); // Remove the anchor from the DOM

            // Revoke the Blob URL
            window.URL.revokeObjectURL(url);
        } catch (e: any) {
            let isNetworkError = false;
            if (e instanceof TypeError) {
                isNetworkError = true;
            }
            throw Object.assign(new Error(`${e as string} ${isNetworkError ? NetworkErrorMessage : ''}`));
        }
    };
    public openFileInBrowser = async (
        commandPath: string,
        query?: URLSearchParams,
        searchKeyword?: string, // Optional search keyword
    ): Promise<void> => {
        // Determine the tenant ID
        const { activeUserInfo } = store.getState().app;
        const tenantId = typeof activeUserInfo?.activeTenantId === 'string' ? activeUserInfo.activeTenantId : EmptyGuid;

        // Create headers
        const headers = new Headers(
            this.accessToken
                ? {
                    Authorization: `Bearer ${this.accessToken}`,
                    'X-Tenant-Id': tenantId,
                }
                : undefined,
        );

        const requestUrl = new URL(commandPath, this.serviceUrl);
        if (query) {
            requestUrl.search = `?${query.toString()}`;
        }

        try {
            const response = await fetch(requestUrl.toString(), {
                method: 'GET',
                headers,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            // Create a Blob URL
            const fileURL = window.URL.createObjectURL(blob);

            // Append the search keyword to the Blob URL if provided
            const fileURLWithSearch = searchKeyword ? `${fileURL}#search=${encodeURIComponent(searchKeyword)}` : fileURL;


            // Open the file in a new browser tab with the search keyword
            window.open(fileURLWithSearch, '_blank');
        } catch (e: any) {
            let isNetworkError = false;
            if (e instanceof TypeError) {
                isNetworkError = true;
            }
            throw Object.assign(new Error(`${e as string} ${isNetworkError ? NetworkErrorMessage : ''}`));
        }
    };

    private base64EncodeUTF8(input: string) {
        const utf8Bytes = new TextEncoder().encode(input);
        return btoa(String.fromCharCode(...utf8Bytes));
    }


    // private normalizeText(text?: string): string {
    // if (!text) return '';
    // // Sadece harf ve rakamları al, küçük harfe çevir
    // return text.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    // }

    public getFileAsBlob = async (
        commandPath: string,
        query?: string,
    ): Promise<Blob> => {
        // Determine the tenant ID
        const { activeUserInfo } = store.getState().app;
        const tenantId = typeof activeUserInfo?.activeTenantId === 'string' ? activeUserInfo.activeTenantId : EmptyGuid;
        
        // let normalizedQuery: string | undefined = undefined;
        // if (query && query.trim() !== '') {
        //     console.log( this.normalizeText(query));
        //     normalizedQuery = query; // this.normalizeText(query);
        // }


        // Create headers
        const headers = new Headers(
            this.accessToken
                ? {
                    Authorization: `Bearer ${this.accessToken}`,
                    'X-Tenant-Id': tenantId,
                    ...(query
                        ? { 'X-Search-Term': this.base64EncodeUTF8(query) }
                        : {}),
                }
                : undefined,
        );

    
        const requestUrl = new URL(commandPath, this.serviceUrl);

        console.log('Download URL:', new URL(commandPath, this.serviceUrl));

        console.log('Request URL:', requestUrl.toString());


        try {
            const response = await fetch(requestUrl.toString(), {
                method: 'GET',
                headers,
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            return await response.blob(); // Return the Blob directly
        } catch (e: any) {
            let isNetworkError = false;
            if (e instanceof TypeError) {
                isNetworkError = true;
            }
            throw Object.assign(new Error(`${e as string} ${isNetworkError ? NetworkErrorMessage : ''}`));
        }
    };
}